export default __webpack_public_path__ + "static/media/card.e6b563c9.png";